import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import {
  Box,
  Button,
  Divider,
  FormControl,
  Grid,
  MenuItem,
  Select,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField
} from '@mui/material'
import React, { useState } from 'react'
import BreadcrumbNavigation from '../commoncomponents/breadcrumbnavigation'
import {
  useGetJobDetailsSingleTask
} from '../../hooks/jobcardHooks'
import _ from 'lodash'
import { useLocation, useParams } from 'react-router-dom'
import InspectionDetailsView from './InspectionDetailsView'
import LinkIcon from '../../assets/svg/LinkIcon'
import { useInspection } from '../../hooks/task'
import { Form, Formik } from 'formik'
import SaveIcon from '../../assets/svg/SaveIcon'
import { useGetfullListOperator } from '../../hooks/resourceHooks'
import { toast } from 'react-toastify'
import { getFileName } from '../../utils'

const Selects = styled(Select)(() => ({
  borderRadius: '4px !important',
  '.MuiOutlinedInput-input': {
    padding: '8.5px 14px',
    fontSize: '14px !important'
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#8A8A8'
  }
}))
const InspectionDetails = () => {
  const selectDepartmentid = localStorage.getItem('selectDepartmentid')
  const [first, setfirst] = useState('')
  const { id } = useParams()
  const { state } = useLocation()
  const { data: getJobDetails } = useGetJobDetailsSingleTask(id, !!id)
  const singleJobDetails = getJobDetails?.data
  const finalBompartData = singleJobDetails?.bompart?.find(
    (data) => data?.id === state?.partId && data
  )
  const findDepartmentSequence = finalBompartData?.bomprocess?.findIndex(item => item?.department?.id === selectDepartmentid)
  const [taskType, setTaskType] = useState('')
  const [open, setOpen] = useState(false)
  const [selectedRow, setSelectedRow] = useState(null)

  const handleOpen = (row) => {
    setSelectedRow(row)
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    setSelectedRow(null)
  }

  const { mutate: updatePart } = useInspection()
  const { data: opratorData } = useGetfullListOperator(selectDepartmentid)

  return (
    <React.Fragment>
      <Box className="production-overflow-hidden">
        <Box>
          <BreadcrumbNavigation
            pageTitle={`Inspection details ( ${
              singleJobDetails?.jobCardNumber
                ? 'JC No. - ' + singleJobDetails?.jobCardNumber
                : '-'
            })`}
            setfirst={setfirst}
            first={first}
          />
        </Box>
        <Box className="padding-24-50">
          <Grid container className="padding-20-40-border">
            <Grid lg={2} md={4}>
              <Box className="add-task-header">Job Card Name</Box>
              <Box className="font-size-14-with-semibold-primary">
                {_.get(singleJobDetails, 'name', '-')}
              </Box>
            </Grid>
            <Grid lg={2} md={4}>
              <Box className="add-task-header">Job Card Number</Box>
              <Box className="font-size-14-with-semibold">
                {_.get(singleJobDetails, 'jobCardNumber', '-')}
              </Box>
            </Grid>
            <Grid lg={2} md={4}>
              <Box className="add-task-header">Customer Name</Box>
              <Box className="font-size-14-with-semibold">
                {_.get(singleJobDetails, 'customerName', '')}
              </Box>
            </Grid>
            <Grid lg={6} md={12} className="align-center-with-gap">
              Status:{' '}
              {singleJobDetails?.jobCardStatus === 'approved' && (
                <>
                  <span className="align-center"></span>{' '}
                  <span className="font-size-14-with-semibold">Approved</span>
                </>
              )}
              {singleJobDetails?.jobCardStatus === 'completed' && (
                <>
                  <span className="align-center">
                    <FiberManualRecordIcon
                      sx={{ fontSize: '14px', color: '#1AD04C' }}
                    />
                  </span>{' '}
                  <span className="font-size-14-with-semibold">Completed</span>
                </>
              )}
            </Grid>
          </Grid>
          <Box sx={{ paddingTop: '16px', paddingLeft: '26px' }}>
              <Grid
                container
                className="padding-20-40-border"
                key={finalBompartData?.id}
              >
                <Grid item lg={2} md={3}>
                  <Box className="add-task-header">Part Name</Box>
                  <Box className="add-task-header-with-semibold">
                    {finalBompartData?.partName}
                  </Box>
                </Grid>
                <Grid item lg={2} md={3}>
                  <Box className="add-task-header">Part Code</Box>
                  <Box className="add-task-header-with-semibold">
                    {finalBompartData?.itemCode}
                  </Box>
                </Grid>
                <Grid item lg={2} md={3}>
                  <Box className="add-task-header">Drawing no.</Box>
                  <Box className="add-task-header-with-semibold">
                    {finalBompartData?.drawingNumber}
                  </Box>
                </Grid>
                <Grid item lg={2} md={3}>
                  <Box className="add-task-header">
                    To be Producted Quantity
                  </Box>
                  <Box className="add-task-header-with-semibold">{finalBompartData?.bomprocess?.[findDepartmentSequence - 1]?.task?.[0]?.producedQuantity}</Box>
                </Grid>
                <Grid item lg={2} md={3}>
                  <Box className="add-task-header">
                    Available for production
                  </Box>
                  <Box className="add-task-header-with-semibold">{finalBompartData?.bomprocess?.[findDepartmentSequence - 1]?.task?.[0]?.producedQuantity}</Box>
                </Grid>
              </Grid>
            <Box sx={{ paddingTop: '16px' }}>
              <Grid container className="padding-20-40-border">
                <Box>
                  <FormControl fullWidth>
                    <Selects
                      name="inspectedBy"
                      variant="outlined"
                      value={taskType}
                      onChange={(e) => setTaskType(e.target.value)}
                      displayEmpty
                    >
                      <MenuItem value="">
                        <span className="menu-item-span">Inspected By</span>
                      </MenuItem>
                      {opratorData?.data?.map(operator => (
                        <MenuItem
                          key={operator.id}
                          value={operator.id}
                        >
                          {operator.name}
                        </MenuItem>
                      ))}
                    </Selects>
                  </FormControl>
                </Box>
                <Box sx={{ paddingLeft: '30px' }}>
                  <Box className="add-task-header">Description</Box>
                  <Box className="add-task-header-with-semibold">
                    {finalBompartData?.description}
                  </Box>
                </Box>
              </Grid>
              <Grid className="approved-padding">
                <Box className="title-typography" pt={3} pb={3}>
                  {finalBompartData?.partName}: Department History
                </Box>
                <Box>
                  <TableContainer sx={{ width: '523px', height: '120px' }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>#</TableCell>
                          <TableCell>Department</TableCell>
                          <TableCell>No. of Tasks Completed </TableCell>
                          <TableCell>Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {finalBompartData?.bomprocess?.filter(process => process?.department?.name !== 'Inspection').map((row, index) => (
                          <TableRow key={index}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>
                              {row.department?.name}
                            </TableCell>
                            <TableCell>
                              {row?.task?.filter(status => status.taskStatus === 'completed')?.length}
                            </TableCell>
                            <TableCell
                              sx={{
                                cursor: 'pointer',
                                color: '#265aa8',
                                fontWeight: 'bold'
                              }}
                              onClick={() => handleOpen(row)}
                            >
                              View
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Divider />
                <Grid>
                  {(finalBompartData?.bomprocess?.filter(process => process?.inspectionTemplate !== '-')?.length) && (
                    <>
                    <Box className="title-typography">Inspection</Box>
                  <Box
                    display="flex"
                    alignItems="center"
                    gap="5px"
                    sx={{
                      border: '1px solid #0160B9',
                      borderRadius: '4px',
                      padding: '10px',
                      height: '10%',
                      width: '15%',
                      overflow: 'hidden'
                    }}
                  >
                   <LinkIcon style={{ color: '#0160B9' }} />
                      <a
                        href={finalBompartData?.bomprocess?.filter(process => process?.inspectionTemplate !== '-')?.[0]?.inspectionTemplate || '#'}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: '#0160B9',
                          cursor: 'pointer',
                          textDecoration: 'none',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          flex: 1
                        }}
                        title={finalBompartData?.bomprocess?.filter(process => process?.inspectionTemplate !== '-')?.[0]?.inspectionTemplate || ''}
                      >
                        {finalBompartData?.bomprocess?.filter(process => process?.inspectionTemplate !== '-')?.[0]?.inspectionTemplate
                          ? getFileName(finalBompartData?.bomprocess?.filter(process => process?.inspectionTemplate !== '-')?.[0]?.inspectionTemplate)
                          : 'No Template'}
                      </a>
                    </Box>
                    </>
                  )}

                  <Box mt={3}>
                    <Formik
                      initialValues={{
                        pass: '',
                        reject: '',
                        rework: '',
                        passWithDeviation: ''
                      }}
                      onSubmit={(values) => {
                        const totalSum = Object.values(values).reduce((acc, val) => {
                          const num = Number(val) || 0 // convert to number, fallback 0 if NaN
                          return acc + num
                        }, 0)
                        const previousDeptTasks = finalBompartData?.bomprocess?.[findDepartmentSequence - 1]?.task
                        const allPreviousTaskCompleted = previousDeptTasks.every(task => task.taskStatus === 'completed')
                        if (allPreviousTaskCompleted) {
                          if (totalSum !== 0 && previousDeptTasks?.[0]?.producedQuantity === totalSum) {
                            const task = finalBompartData?.bomprocess?.find(item => item?.department?.id === selectDepartmentid)
                            const taskId = task?.task?.[0]?.id
                            if (taskId) {
                              updatePart({ id: taskId, ...values, operator: taskType })
                            } else {
                              console.error('Task ID not found!')
                            }
                          } else {
                            toast.error('Please entered correct quantity')
                          }
                        } else {
                          toast.error('Please complete previous department all task')
                        }
                      }}
                    >
                      {({ values, handleChange }) => (
                        <Form>
                          <TableContainer
                            sx={{
                              border: '1px solid #E0E0E0',
                              borderRadius: '8px',
                              maxWidth: '650px'
                            }}
                          >
                            <Table size="small">
                              <TableHead sx={{ backgroundColor: '#f9f9f9' }}>
                                <TableRow>
                                  <TableCell>#</TableCell>
                                  <TableCell>States</TableCell>
                                  <TableCell>Quantity</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {[
                                  { label: 'Pass', name: 'pass' },
                                  {
                                    label: 'Pass with Deviation',
                                    name: 'passWithDeviation'
                                  },
                                  { label: 'Rework', name: 'rework' },
                                  { label: 'Reject', name: 'reject' }
                                ].map((row, index) => (
                                  <TableRow key={row.name}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{row.label}</TableCell>
                                    <TableCell>
                                      <Box
                                        display="flex"
                                        alignItems="center"
                                        gap={1}
                                      >
                                        <TextField
                                          variant="outlined"
                                          size="small"
                                          type="text"
                                          placeholder="Enter Qty"
                                          name={row.name}
                                          value={values[row.name]}
                                          onChange={handleChange}
                                        />
                                        <Box
                                          sx={{
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            border: '1px solid #0160B9',
                                            borderRadius: '4px',
                                            width: '30px',
                                            height: '30px'
                                          }}
                                        >
                                          <SaveIcon />
                                        </Box>
                                      </Box>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>

                          {/* Buttons */}
                          <Box className="footer-action-buttons">
                            <Button
                              variant="outlined"
                              type="button"
                              sx={{ textTransform: 'none', marginRight: '8px' }}
                            >
                              Cancel
                            </Button>
                            <Button
                              variant="contained"
                              type="submit"
                              sx={{
                                backgroundColor: '#0160B9',
                                textTransform: 'none'
                              }}
                            >
                              Submit
                            </Button>
                          </Box>
                        </Form>
                      )}
                    </Formik>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
        <InspectionDetailsView
          open={open}
          DetailsHandleClose={handleClose}
          selectedRow={selectedRow}
          finalBompartData={finalBompartData}
        />
      </Box>
    </React.Fragment>
  )
}
export default InspectionDetails
